import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { CommonModalFormComponent } from '@shared/components/commons/common-modal-form/common-modal-form.component';
import { InputComponent } from '@shared/controls/input/input.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IntegrationsApiService } from '@shared/services/integrations-api.service';
import { AnnatureConnection } from '../../../../../../models/annature/annature-connection';
import { IntegrationConnectionsEnum } from '@models/integrations/integration-connections.enum';
import { ToastrService } from 'ngx-toastr';
import { ConnectionStatusEnum } from '@models/integrations/connection-status.enum';

@Component({
  selector: 'app-annature-login-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputComponent,
    CommonModalFormComponent,
  ],
  templateUrl: 'annature-login-modal.component.html',
})

export class AnnatureLoginModalComponent {
  private activeModal = inject(NgbActiveModal);
  private integrationsService = inject(IntegrationsApiService);
  private toastr = inject(ToastrService);

  @Output() confirmEvent = new EventEmitter<ConnectionStatusEnum>();

  isLoading = signal(false);
  form = new FormGroup({
    clientId: new FormControl<string | null>(null, [Validators.required]),
    clientKey: new FormControl<string | null>(null, [Validators.required]),
  });

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = new AnnatureConnection(this.form.value as Partial<AnnatureConnection>);

    this.isLoading.set(true);
    this.form.disable();

    this.integrationsService.connectByKeys(IntegrationConnectionsEnum.AnnatureConnection, payload)
      .subscribe({
        next: (status) => {
          if (status === ConnectionStatusEnum.RequiredAction) {
            this.toastr.warning('Connection Success!', 'Required Action');
          } else {
            this.toastr.success('Connected!', 'Success');
          }

          this.confirmEvent.emit(status);
          this.activeModal.close();
        },
        error: () => {
          this.isLoading.set(false);
          this.form.enable();
          this.toastr.error('Connection Failed!', 'Error');
        }
      });
  }

  close(): void {
    this.activeModal.close();
  }
}
